import { render, staticRenderFns } from "./AdUnit.vue?vue&type=template&id=215a65c0&scoped=true&"
import script from "./AdUnit.vue?vue&type=script&lang=ts&"
export * from "./AdUnit.vue?vue&type=script&lang=ts&"
import style0 from "./AdUnit.vue?vue&type=style&index=0&id=215a65c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a65c0",
  null
  
)

export default component.exports